import FieldFileUpload from './FieldFileUpload';

export default FieldFileUpload;
